import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { projectNameMap } from '@constants'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { TrashOutlined } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useCallback, useRef, useState } from 'react'
import { useStmCart } from '../CartProvider'
import { PopConfirmDiscardCart } from './PopConfirmDiscardCart'

export const CartBrandHeader = () => {
  const { campaignId, projectCode, platform } = useStmCart()
  const { isCartEmpty } = useFpB2bCartService(campaignId, platform)
  const [isPopConfirmOpen, setIsPopConfirmOpen] = useState(false)
  const discardButtonRef = useRef<HTMLDivElement>(null)
  const brandName = projectNameMap[projectCode] ?? projectCode

  const handleClosePopConfirm = useCallback(() => setIsPopConfirmOpen(false), [])

  if (isCartEmpty) return null

  return (
    <HStack px={3} py={2} justifyContent="space-between" alignItems="center" backgroundColor={colors.blueGrey200} borderTopLeftRadius={8} borderTopRightRadius={8}>
      <Text color={colors.grey800}>{brandName}</Text>
      <Box rootRef={discardButtonRef} display="inline-flex">
        <Button variant="text" color="grey" onClick={() => setIsPopConfirmOpen(prev => !prev)}>
          <TrashOutlined fontSize={20} color={colors.grey500} />
        </Button>
      </Box>
      <PopConfirmDiscardCart
        open={isPopConfirmOpen}
        anchorEl={discardButtonRef.current}
        onClose={handleClosePopConfirm}
      />
    </HStack>
  )
}
